import { useUserAgentInfo } from '../context/user-agent';
export default useUserAgentInfo;
